import { createFrontendModule } from '@backstage/frontend-plugin-api'
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha'
import { Entity } from '@backstage/catalog-model'

const KUBERNETES_ID = 'backstage.io/kubernetes-id'
const KUBERNETES_LABEL_SELECTOR = 'backstage.io/kubernetes-label-selector'

// Same id as the Kubernetes plugin's entity-content:kubernetes/kubernetes, so this replaces the stock tab.
const kubernetesContent = EntityContentBlueprint.make({
  name: 'kubernetes',
  params: {
    path: '/kubernetes',
    title: 'Kubernetes',
    group: 'deployment',
    filter: (entity: Entity) =>
      Boolean(
        entity.metadata.annotations?.[KUBERNETES_ID] ??
          entity.metadata.annotations?.[KUBERNETES_LABEL_SELECTOR],
      ),
    loader: async () => {
      const { KubernetesContent } = await import('./KubernetesContent')
      return <KubernetesContent />
    },
  },
})

export const dgKubernetesModule = createFrontendModule({
  pluginId: 'kubernetes',
  extensions: [kubernetesContent],
})
